import { useTranslation } from 'next-i18next';
import React from 'react';
import styled from 'styled-components';
import { card } from '@hotelplan/components.common.mixins';
import { RouterLink } from '@hotelplan/components.common.router-link';
import { EPageType } from '@hotelplan/fdr.lib.page.available-pages';
import { targetPageData } from '@hotelplan/fdr.lib.router.target-page-data';
import { getRouteByPageTypeLocale } from '@hotelplan/libs.router-config';
import { FdrLinkType } from '@hotelplan/supergraph-api';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import { WishlistLinkWrapper } from './WishlistCompareNotSelectedItemInfo';

const windowWrapStyles = sx2CssThemeFn({
  minWidth: [null, '500px'],
  mx: 'auto',
  p: [5, 6],
  textAlign: 'center',
});

const wrapperStyles = sx2CssThemeFn({
  m: '0 auto',
  py: [5, 7],
  px: [4, 0],
});

const WishlistEmptyWrapper = styled.div(wrapperStyles);

const WindowWrapper = styled.div(
  sx2CssThemeFn(card),
  windowWrapStyles,
  ({ theme: { space, FONT_SIZE } }) =>
    sx2CssThemeFn({
      '.empty-wishlist-window-title': {
        marginBottom: space[2],
        ...FONT_SIZE.M,
      },
      '.empty-wishlist-window-text': {
        marginBottom: [3, 4],
        ...FONT_SIZE.MEDIUM,
      },
    })
);

export const WishlistEmpty: React.FC = () => {
  const [t, { language }] = useTranslation('wishlist');

  const searchRoute = getRouteByPageTypeLocale(EPageType.Srl, language);
  const searchRouterProps = targetPageData({
    __typename: 'FdrLink',
    url: searchRoute.builder({}),
    type: FdrLinkType.Internal,
  });

  return (
    <WishlistEmptyWrapper>
      <WindowWrapper>
        <h3 className="empty-wishlist-window-title">
          {t('wishlist:emptyWishlistWindow.title')}.
        </h3>
        <p className="empty-wishlist-window-text">
          {t('wishlist:emptyWishlistWindow.text')}.
        </p>
        <RouterLink {...searchRouterProps} passHref>
          <WishlistLinkWrapper>
            {t('wishlist:emptyWishlistWindow.button')}
          </WishlistLinkWrapper>
        </RouterLink>
      </WindowWrapper>
    </WishlistEmptyWrapper>
  );
};
